"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _hubspot = _interopRequireDefault(require("hubspot"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var flagsImagePath = (_hubspot.default.bender && _hubspot.default.bender.staticDomainPrefix) + "/ui-addon-i18n/static-1.2545/img/flags.png";

var _default = _react.default.createClass({
  displayName: "CountryFlag",
  propTypes: {
    countryCode: _react.PropTypes.string.isRequired
  },
  getFlagStyle: function getFlagStyle() {
    return {
      backgroundImage: "url(" + flagsImagePath + ")"
    };
  },
  render: function render() {
    var _this$props = this.props,
        countryCode = _this$props.countryCode,
        className = _this$props.className,
        passThroughProps = (0, _objectWithoutProperties2.default)(_this$props, ["countryCode", "className"]);
    return _react.default.createElement("span", (0, _extends2.default)({}, passThroughProps, {
      className: (0, _classNames.default)('country-flag', className, countryCode.toLowerCase()),
      style: this.getFlagStyle()
    }));
  }
});

exports.default = _default;
module.exports = exports.default;